import React, { useEffect, useState } from 'react';
import { Plus, X } from 'react-feather';
import '../../styles/cardStyles.css';
import { MRSitesProvidersNotesReportsGet } from 'apiServices/reducer/apiService';
import { useDispatch, useSelector } from 'react-redux';
import CTGrid from '../../components/Grid/CTGrid';

const ProviderNotesCard = ({
  userId: dashboardUserId,
  showAddButton,
  onAdd,
  onRemove,
  widgetName,
  draggable = false,
  onDragStart,
  selectedFamilyMember,
  onRowClickforLabResults
}) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.apiService.login);
  const isProvider = userData.user_type_name === 'Provider';

  // Use selectedFamilyMember's user_id if available, otherwise use current user's ID
  const userId = selectedFamilyMember?.user_id || dashboardUserId || (isProvider ? localStorage.getItem('patientUserId') : userData.user_id);

  const token = useSelector((state) => state.apiService?.token);
  const [providerData, setProviderData] = useState([]);

  useEffect(() => {
    if (userId && token) {
      dispatch(MRSitesProvidersNotesReportsGet({ UserID: userId, token }))
        .then((res) => {
          if (res?.payload!==undefined&&res?.payload!==null) {
            const providerNotesData = res.payload;
            console.log(providerNotesData, "providerNotesData")
            const formattedData = providerNotesData.map(providerNotes => ({
              report_name: providerNotes.report_name,
              date: providerNotes.report_date,
              group_name: providerNotes.group_name,
              clinic: providerNotes.hospital_name,
              url: providerNotes.report_path,
              reportId: providerNotes.report_id,
              group_id: providerNotes.group_id,
              provider_name: providerNotes.provider_name,
              report_path: providerNotes.report_path,
              edit_report_name: providerNotes.edit_report_name
            }));
            setProviderData(formattedData);
            console.log(providerData, "providerData")
          } else {
            setProviderData([]);
          }
        })
        .catch((err) => {
          console.error("Error fetching provider notes:", err);
          setProviderData([]);
        });
    }
  }, [userId, token, dispatch, selectedFamilyMember]);
  const cellRendererWithTooltip = (params) => {
    console.log(params, "params at cellRendererWithTooltip")
    const value = params.data.date || "N/A";
    return (
      <div
        style={{
          fontSize: '12px',
          color: '#6b7280',
          fontWeight: '500'
        }}
      >
        {value}
      </div>
    );
  };
  const cellRendererWithTooltipforCategory = (params) => {
    console.log(params, "params at cellRendererWithTooltip")
    const value = params.data.group_name || "N/A";
    return (
      <div
        style={{
          fontSize: '12px',
          color: '#6b7280',
          fontWeight: '500'
        }}
      >
        {value}
      </div>
    );
  };
  // CTGrid column definitions
  const columnDefs = [
    {
      headerName: "Report Name",
      field: "report_name",
      width: 140,
      tooltipField: "report_name",
      headerTooltip: "Report Name",
      wrapText: true,
      autoHeight: true,
      cellClass: 'provider-notes-report-name-wrap',
      cellRenderer: (params) => {
        console.log(params.data, "params at Provider Notes")
        const name = params.data?.edit_report_name || params.data?.report_name || "N/A";
        const path = params.data?.report_path;
        return path ? (
          <div
            rel="noopener noreferrer"
            className="text-decoration-underline"
            style={{
              fontSize: '12px',
              color: '#6b7280',
              fontWeight: '500',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              lineHeight: '1.5',
              width: '100%'
            }}
          //  title={name}  // Tooltip for link
          >
            {name}
          </div>
        ) : (
          <div
            style={{ 
              fontSize: '12px',
              color: '#6b7280',
              fontWeight: '500',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'anywhere',
              lineHeight: '1.5',
              width: '100%'
            }}
            title="N/A"
          >
            N/A
          </div>
        );
      },
    },
    {
      headerName: "Report Date",
      field: "report_date",
      filter: true,
      tooltipField: "report_date",
      headerTooltip: "Report Date",
      width: 125,
      cellRenderer: cellRendererWithTooltip,
      className: "text-center"

    },
    {
      headerName: "Report Type",
      field: "group_name",
      filter: true,
      width: 128,
      tooltipField: "group_name",
      headerTooltip: "Report Type",
      cellRenderer: cellRendererWithTooltipforCategory,

    }
  ];
  // upcoming-widget-cardwidget allergy-card-container 

  return (
    <div
      className="cardwidget  cardwidgetHeight shadow-lg shadow-sm border-0 mb-3 rounded-3"
      draggable={draggable}
      onDragStart={onDragStart}
    >
      <div className="cardwidget-header cardwidgehtHeaderBG d-flex justify-content-between align-items-center px-3 py-1">
        <h6 className="mb-0 text-capitalize">{widgetName || "Provider Notes"}</h6>
        {showAddButton ? (
          <button
            className="btn btn-sm px-0"
            onClick={onAdd}
            title="Add to Dashboard"
          >
            <Plus size={15} />
          </button>
        ) : (
          <button
            className="btn btn-sm px-0"
            onClick={onRemove}
            title="Remove from Dashboard"
          >
            <X size={15} />
          </button>
        )}
      </div>

      <div className="cardwidget-body px-3 py-2 cardwidgetProvidernotesBodyHeight">
        {providerData.length === 0 ? (
          <p className="text-muted px-3 pt-2">No provider notes available.</p>
        ) : (
          <CTGrid
            rowData={providerData}
            columnDefs={columnDefs}
            height="170px"
            onRowClickforLabResults={onRowClickforLabResults}
              enableBrowserTooltips={true}
              tooltipShowDelay={0}
          />

        )}
      </div>
    </div>
  );
};

export default ProviderNotesCard;
